export const MULTIPLE_INVESTMENTS_TYPE = 'multipleInvestments' as const;
